<template>
  <!-- 搜索栏 -->
  <div class="search-box">
    <div class="search-box-info">
      <div class="search-box-info-left">
      <img class="logo" :src="config.logo" alt=""/>
        <img v-if="isTeacher()" class="teachers" :src="getOnLineAssets('pc_Serach_teacher_t.jpg?v=333')" alt=""/>
      </div>
      <div class="search">
        <div class="left-list">
          <div class="left_title">全国服务热线：</div>
          <div class="left_content">{{ config.hotline_phone }}</div>
        </div>
<!--        <div class="right-list show_xcx">-->
<!--          <img src="https://oss.shudaozaixian.com/assets/pc_Small_Program_First.png" alt=""/>-->
<!--          <div class="right_content">小程序</div>-->
<!--          <div class="xcx_class">-->
<!--            <img style="margin: 0 auto; width: 100px; height: 100px" :src="config.wx_mini_url" alt=""/>-->
<!--          </div>-->
<!--        </div>-->
        <div class="position" v-if="provinceName">
          <el-select v-model="provinceName" placeholder="" size="default" style="width: 100px"
                     suffix-icon="LocationInformation" :disabled="true">
            <template #suffix>
              <LocationInformation/>
            </template>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {LocationInformation} from "@element-plus/icons-vue";
import {getOnLineAssets, isTeacher} from "@/utils/publicMethonds";

export default {
  methods: {isTeacher, getOnLineAssets},
  components: {LocationInformation},
  data() {
    return {
      search: "",
      value: "",
      province_name: '',
      config: {
        address: "",
        banner: "",
        bottom_banner: "",
        copyright: "",
        domain: "",
        email: "",
        hotline_phone: "",
        icp: "",
        logo: "",
        name: "",
        phone: "",
        website_title: "",
        wx_mini_url: "",
        wx_offiaccount_url: "",
      },
      options: [
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
      ],
    };
  },
  computed:{
    provinceName(){
      return this.userBaseInfo.province_name || ''
    }
  },
  beforeRouteLeave() {
    },
  created() {
      this.config = this.getGlobalConfig()
    }
};
</script>

<style lang="scss" scoped>
@import "@/style/var.scss";

.search-box {
  width: 100%;
  // margin: 10px 0;
  background: #F9F9F9;

  .search-box-info {
    height: 88px;
    width: 1230px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .search-box-info-left{
      display: flex;
      align-items: center;
    .logo {
        height: 63px;
      margin: 6px 0;
    }
      .teachers{
        height: 36px;
        margin-left: 8px;
      }
    }


    .search {
      min-width: 420px;
      height: 42px;
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .search-ipt {
        width: 450px;
        height: 46px;
        border-radius: 4px;

        .icon {
          width: 25px;
          cursor: pointer;
          height: 100%;
          display: flex;
          align-items: center;
        }
      }

      img {
        width: 118px;
        height: 46px;
        border-radius: 4px;
        margin-left: 20px;
        cursor: pointer;
      }

      .left-list {
        display: flex;
        width: 221px;
        height: 20px;
        align-items: center;

        .left_title {
          font-weight: 400;
          font-size: 16px;
          color: #999999;
        }

        .left_content {
          color: #FF1818;
        }
      }

      .right-list {
        display: flex;
        align-items: center;
        // margin: 0 24px 0 0;
        position: relative;

        img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          margin-top: 3px;
        }

        .xcx_class {
          position: absolute;

          img {
            position: absolute;
            // right: 420px;
            top: 20px;
            display: none;
            z-index: 1;
          }
        }
      }

      .right-list:hover .xcx_class img {
        display: inline-block;
      }

      .position {
        margin-left: 32px;
      }
    }
  }
}

:deep(.el-input__icon) {
  font-size: 20px;
}

:deep(.el-select__placeholder).is-transparent {
  color: #333333;
}

:deep(.el-select__suffix) {
  color: #2285ff;
}

:deep(.el-select__prefix) {
  color: #000;
}

:deep(.el-select__caret).is-reverse {
  transform: rotate(0);
}
</style>
